import React from "react";
import ProfilePageTemplate from "../shared/ProfilePageTemplate";
import BTNCLOOverviewContent from "./BTNCLOOverviewContent";
import BTNCLOHistoryContent from "./BTNCLOHistoryContent";
import BTNCLORegionsContent from "./BTNCLORegionsContent";
import BTNCLOActivitiesContent from "./BTNCLOActivitiesContent";

const BTNCLOContent = () => {
  const tabs = [
    {
      id: "overview",
      label: "Gambaran Umum",
      icon: "🏛️",
      component: <BTNCLOOverviewContent />,
    },
    {
      id: "history",
      label: "Sejarah",
      icon: "📜",
      component: <BTNCLOHistoryContent />,
    },
    {
      id: "regions",
      label: "Wilayah Kerja",
      icon: "🗺️",
      component: <BTNCLORegionsContent />,
    },
    {
      id: "activities",
      label: "Kegiatan",
      icon: "📊",
      component: <BTNCLOActivitiesContent />,
    },
  ];

  return (
    <ProfilePageTemplate
      title="BTNCLO"
      subtitle="Border Transnational Crime Liaison Officer"
      icon="🔍"
      breadcrumbBase="NCB-Interpol"
      tabs={tabs}
      footerTitle="BTNCLO Indonesia"
      footerDescription="Berkomitmen dalam penanggulangan kejahatan transnasional di wilayah perbatasan melalui koordinasi dan kerjasama yang efektif dengan berbagai pihak terkait."
      footerStats={[
        { label: "Polda dengan BTNCLO", value: "13" },
        { label: "Wilayah Perbatasan", value: "Multi-Region" },
        { label: "Operasional", value: "24/7" },
      ]}
    />
  );
};

export default BTNCLOContent;
